module.exports = __webpack_public_path__ + "img/login.89af9d34.png";